import readXlsxFile from 'read-excel-file';
import type { DraftRosterRow } from '@/composables/useOrderAssistant';

/**
 * AB#21824 — rows of a roster sheet (the template from Create manual order),
 * for the Create with ELSA draft. Columns are resolved by header, as the form
 * does (bug 19533). The form re-parses the same sheet at review, so this only
 * has to be right enough for ELSA to see the sizes and quantities.
 */
export const readRosterSheet = async (file: File): Promise<DraftRosterRow[]> => {
  const rows = await readXlsxFile(file);
  const header = (rows[0] || []).map((h) =>
    h === null || h === undefined ? '' : String(h).trim()
  );
  const col = {
    name: header.indexOf('NAME ON PRODUCT'),
    number: header.indexOf('NUMBER'),
    size: header.indexOf('SIZE*'),
    quantity: header.indexOf('QUANTITY*'),
  };
  if (col.size === -1 || col.quantity === -1) {
    throw new Error('Not a roster template');
  }
  const cell = (row: unknown[], i: number): string =>
    i === -1 || row[i] === undefined || row[i] === null ? '' : String(row[i]).trim();
  const out: DraftRosterRow[] = [];
  for (const row of rows.slice(1)) {
    const size = cell(row, col.size);
    const qty = cell(row, col.quantity);
    if (!size || !qty) continue;
    const quantity = parseInt(qty, 10);
    if (!Number.isFinite(quantity) || quantity < 0) continue;
    out.push({ size, quantity, name: cell(row, col.name), number: cell(row, col.number) });
  }
  return out;
};
